<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="cover" id="cover">
<img alt="Brother Blood Sister Death" class="cover-image" src="images/bbsd-bkdgcx.jpg"/>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// cover.vue?8f196634